var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"me-3",staticStyle:{"width":"115px"},attrs:{"variant":"primary"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('b-icon',{attrs:{"icon":"file-earmark-arrow-down-fill","aria-hidden":"true"}}),_vm._v(" Download ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }